export function scrollToLocation() {
    var _hash = window.location.hash.replace(/\//g, "");
    if (_hash.length > 0) {
        var _id = _hash.replace(/#/gi, '');
        var to = $('[data-id="' + _id + '"]').offset().top - $(".header").innerHeight();
        $('html, body').animate({scrollTop: to}, 800);
        window.history.pushState("", document.title, window.location.pathname);
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/scroll-to-location.js